const Index = () => {

    return (
        <div className="d-flex justify-content-center align-items-center pt-5">
           <div className="p-5" style={{
              //  border:"1px solid #C33B32",
                borderRadius:"12px",
                boxShadow: "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px"
           }}>
                <div>You are restricted from viewing this page.</div>
                <div>Please contact our customer service at 03-2147 1900 for further assistance. Thank you.</div>
           </div>
        </div>
    );
};


export default Index;
